export default "__VITE_ASSET__Cyy4ZBEx__"